import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { extractErrorMessage, extractErrorCode } from '../../../utils/apiResponseHandler';
import { Error } from '../../actions/error/error';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/foundation/byomDownload';

function* process(action) {
  try {
    const { blueprint_id } = action.payload;
    const url = `${config.API_URL}/models/byom/${blueprint_id}/download`;
    const response = yield call(axios.get, url, { headers: getLocalUser() });
    const data = response.data?.data || response.data;
    // Kick off the browser download immediately - the presigned URL
    // is time-limited, so there's no value in making the user click
    // a second time.
    if (data?.download_url) {
      const a = document.createElement('a');
      a.href = data.download_url;
      a.download = data.filename || 'model';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
    yield put(fetchSuccess(data));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure({
      message: extractErrorMessage(error),
      code: extractErrorCode(error),
    }));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, process);
}
